import { useEffect, useState } from 'react';
import { TopSpendByDepartmentAPI, TopSpendByItemQuantityAPI, TopSpendByItemSpendAPI, TopSpendByJobNameAPI, TopSpendByStoreAPI, } from '../api/oms/business-tools';
export var GetTopSpendByJobName = function (requestData, setTopJobs) {
    var _a = useState(null), jobNameData = _a[0], setJobNameData = _a[1];
    var _b = useState(null), jobNameError = _b[0], setJobNameError = _b[1];
    var _c = useState(false), jobNameLoaded = _c[0], setJobNameLoaded = _c[1];
    useEffect(function () {
        /**
         * Used to the spinner to show on each api call
         * @setJobNameLoaded
         */
        setJobNameLoaded(false);
        TopSpendByJobNameAPI(requestData)
            .then(function (response) {
            setJobNameData(response.data);
            if (setTopJobs) {
                var topSpendJobs = response.data.businessToolsResponse.jobsSpend;
                setTopJobs(topSpendJobs.length > 0 ? topSpendJobs : []);
            }
        })
            .catch(function (error) { return setJobNameError(error); })
            .finally(function () { return setJobNameLoaded(true); });
    }, [
        requestData.businessToolsRequest.startDate,
        requestData.businessToolsRequest.endDate,
        requestData.businessToolsRequest.jobName,
    ]);
    return { jobNameData: jobNameData, jobNameError: jobNameError, jobNameLoaded: jobNameLoaded };
};
export var GetTopSpendByStore = function (requestData) {
    var _a = useState(null), topSpendByStore = _a[0], setTopSpendByStore = _a[1];
    var _b = useState(null), topSpendByStoreError = _b[0], setTopSpendByStoreError = _b[1];
    var _c = useState(false), topSpendByStoreLoaded = _c[0], setTopSpendByStoreLoaded = _c[1];
    useEffect(function () {
        setTopSpendByStoreLoaded(false);
        TopSpendByStoreAPI(requestData)
            .then(function (response) {
            return setTopSpendByStore(response.data);
        })
            .catch(function (error) { return setTopSpendByStoreError(error); })
            .finally(function () { return setTopSpendByStoreLoaded(true); });
    }, [
        requestData.businessToolsRequest.startDate,
        requestData.businessToolsRequest.endDate,
        requestData.businessToolsRequest.jobName,
    ]);
    return { topSpendByStore: topSpendByStore, topSpendByStoreError: topSpendByStoreError, topSpendByStoreLoaded: topSpendByStoreLoaded };
};
export var GetTopSpendByDepartment = function (requestData) {
    var _a = useState(null), jobDepartmentData = _a[0], setJobDepartmentData = _a[1];
    var _b = useState(null), jobDepartmentError = _b[0], setJobDepartmentError = _b[1];
    var _c = useState(false), jobDepartmentLoaded = _c[0], setJobDepartmentLoaded = _c[1];
    useEffect(function () {
        setJobDepartmentLoaded(false);
        TopSpendByDepartmentAPI(requestData)
            .then(function (response) {
            return setJobDepartmentData(response.data);
        })
            .catch(function (error) { return setJobDepartmentError(error); })
            .finally(function () { return setJobDepartmentLoaded(true); });
    }, [
        requestData.businessToolsRequest.startDate,
        requestData.businessToolsRequest.endDate,
        requestData.businessToolsRequest.jobName,
    ]);
    return { jobDepartmentData: jobDepartmentData, jobDepartmentError: jobDepartmentError, jobDepartmentLoaded: jobDepartmentLoaded };
};
/**
 * These two api's will not have local hooks but will use state setters
 * from parent, this will update item spend with proper data.
 */
export var GetTopSpendByItemSpend = function (requestData, setTopItems, setTopItemsError, setTopItemsLoaded) {
    setTopItemsLoaded(false);
    TopSpendByItemSpendAPI(requestData)
        .then(function (response) {
        return setTopItems(response.data.businessToolsResponse.itemSpend);
    })
        .catch(function (error) { return setTopItemsError(error); })
        .finally(function () { return setTopItemsLoaded(true); });
};
export var GetTopSpendByItemQuantity = function (requestData, setTopItems, setTopItemsError, setTopItemsLoaded) {
    setTopItemsLoaded(false);
    TopSpendByItemQuantityAPI(requestData)
        .then(function (response) {
        return setTopItems(response.data.businessToolsResponse.itemQuantity);
    })
        .catch(function (error) { return setTopItemsError(error); })
        .finally(function () { return setTopItemsLoaded(true); });
};
